var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.31111C1 2.50215 1 2.09766 1.15743 1.78868C1.29592 1.51689 1.51689 1.29592 1.78868 1.15743C2.09766 1 2.50215 1 3.31111 1H24.6889C25.4979 1 25.9024 1 26.2113 1.15743C26.4832 1.29592 26.704 1.51689 26.8426 1.78868C27 2.09766 27 2.50215 27 3.31111V5.82049C27 6.17378 27 6.35042 26.9601 6.51667C26.9247 6.66406 26.8664 6.80495 26.7871 6.93418C26.6978 7.07996 26.5729 7.20487 26.3231 7.45469L17.5658 16.212C17.316 16.4618 17.1911 16.5867 17.1018 16.7325C17.0225 16.8617 16.9641 17.0026 16.9288 17.15C16.8889 17.3163 16.8889 17.493 16.8889 17.8461V21.2222L11.1111 27V17.8461C11.1111 17.493 11.1111 17.3163 11.0712 17.15C11.0358 17.0026 10.9775 16.8617 10.8983 16.7325C10.8089 16.5867 10.684 16.4618 10.4342 16.212L1.67691 7.45469C1.42709 7.20487 1.30218 7.07996 1.21285 6.93418C1.13365 6.80495 1.0753 6.66406 1.03991 6.51667C1 6.35042 1 6.17378 1 5.82049V3.31111Z",
    stroke: "#662D91",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.ffb6f04ec48cfb1985cf36f9dd7befeb.svg";
export { ForwardRef as ReactComponent };